import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import { loginAtom } from '../../store/auth';
import { Loader2 } from 'lucide-react';
import { getRedirectInfo, clearRedirectInfo } from '../../utils/auth';

export const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const login = useSetAtom(loginAtom);

  useEffect(() => {
    const token = searchParams.get('token');
    const userStr = searchParams.get('user');

    if (token && userStr) {
      try {
        const user = JSON.parse(userStr);
        login({ token, user });
        
        // Check if we have redirect information
        const { path } = getRedirectInfo();
        
        // Navigate to the stored path or dashboard as default
        const redirectPath = path || '/dashboard';
        
        // Clear redirect info after using it
        clearRedirectInfo();
        
        navigate(redirectPath);
      } catch (error) {
        console.error('Failed to parse user data:', error);
        navigate('/login');
      }
    } else {
      navigate('/login');
    }
  }, [searchParams, login, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}; 